/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export function isAdult(birth: string) {
    if (!birth || birth.length < 6) return false;

    const day = parseInt(birth.substring(0, 2), 10);
    const month = parseInt(birth.substring(2, 4), 10) - 1;
    const year = birth.length === 8
        ? parseInt(birth.substring(4, 8), 10)
        : parseInt('19' + birth.substring(4, 6), 10);

    const birthDate = new Date(year, month, day);
    if (isNaN(birthDate.getTime())) return false;

    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    return (
        age > 18 ||
        (age === 18 && m >= 0 && today.getDate() >= birthDate.getDate())
    );
}